import clsx from 'clsx';

type LoadingDotsProps = {
  background?: string;
};

export const LoadingDots = ({ background = 'bg-secondary dark:bg-primary' }: LoadingDotsProps) => {
  const baseClassNames = 'w-3 h-3 rounded-full animate-loading-dot';
  return (
    <div className="flex items-center justify-center space-x-2 h-4">
      <div className={clsx(baseClassNames, background)} />
      <div className={clsx(baseClassNames, background, 'delay-150')} />
      <div className={clsx(baseClassNames, background, 'delay-300')} />
    </div>
  );
};
